import { render, staticRenderFns } from "./LimitConfigurationDialog.vue?vue&type=template&id=01c5c895&scoped=true"
import script from "./LimitConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./LimitConfigurationDialog.vue?vue&type=script&lang=js"
import style0 from "./LimitConfigurationDialog.vue?vue&type=style&index=0&id=01c5c895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5c895",
  null
  
)

export default component.exports